import React from 'react'
import { MenuBook as DocsIcon, SmartToy as AgentIcon } from '@mui/icons-material'
import { ChatMode } from '../types'

interface ModeToggleProps {
    mode: ChatMode
    onChange: (mode: ChatMode) => void
    showAgent?: boolean
}

const containerStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    background: 'var(--border-color, #e2e8f0)',
    borderRadius: 20,
    padding: 2,
    gap: 2,
}

const getButtonStyle = (active: boolean): React.CSSProperties => ({
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    padding: '5px 12px',
    border: 'none',
    borderRadius: 18,
    fontSize: 11,
    fontWeight: 700,
    cursor: active ? 'default' : 'pointer',
    letterSpacing: '0.4px',
    textTransform: 'uppercase' as const,
    transition: 'all 0.18s ease',
    background: active ? 'var(--card-bg, #ffffff)' : 'transparent',
    color: active ? 'var(--main-accent, #3b82f6)' : 'var(--main-text-secondary, #64748b)',
    boxShadow: active ? '0 1px 4px rgba(0,0,0,0.12)' : 'none',
    outline: 'none',
})

export const ModeToggle: React.FC<ModeToggleProps> = ({ mode, onChange, showAgent = true }) => {
    return (
    <div style={containerStyle} role="group" aria-label="Chat mode">
        <button
            style={getButtonStyle(mode === 'docs')}
            onClick={() => onChange('docs')}
            aria-pressed={mode === 'docs'}
            aria-label="Docs mode"
            disabled={mode === 'docs'}
        >
            <DocsIcon style={{ fontSize: 13 }} />
            Docs
        </button>
        {showAgent && (
            <button
                style={getButtonStyle(mode === 'agent')}
                onClick={() => onChange('agent')}
                aria-pressed={mode === 'agent'}
                aria-label="Agent mode"
                disabled={mode === 'agent'}
            >
                <AgentIcon style={{ fontSize: 13 }} />
                AI Agent
            </button>
        )}
    </div>
    )
}

export default ModeToggle
